const SEPARATOR = /(\s+)/;

const MAX_TOKENS = 400;

function tokenize(text) {
  return String(text ?? '').split(SEPARATOR).filter((token) => token !== '');
}

export function wordDiff(before, after) {
  const a = tokenize(before);
  const b = tokenize(after);
  const parts = [];

  function push(type, text) {
    if (!text) return;
    const last = parts[parts.length - 1];
    if (last && last.type === type) last.text += text;
    else parts.push({ type, text });
  }

  // Trimming the shared ends first is what makes a one-word edit cheap
  let start = 0;
  while (start < a.length && start < b.length && a[start] === b[start]) start += 1;
  let endA = a.length;
  let endB = b.length;
  while (endA > start && endB > start && a[endA - 1] === b[endB - 1]) {
    endA -= 1;
    endB -= 1;
  }

  push('same', a.slice(0, start).join(''));

  const midA = a.slice(start, endA);
  const midB = b.slice(start, endB);

  if (midA.length > MAX_TOKENS || midB.length > MAX_TOKENS) {
    push('del', midA.join(''));
    push('ins', midB.join(''));
  } else {
    const n = midA.length;
    const m = midB.length;
    const lcs = Array.from({ length: n + 1 }, () => new Uint16Array(m + 1));
    for (let i = n - 1; i >= 0; i -= 1) {
      for (let j = m - 1; j >= 0; j -= 1) {
        lcs[i][j] = midA[i] === midB[j]
          ? lcs[i + 1][j + 1] + 1
          : Math.max(lcs[i + 1][j], lcs[i][j + 1]);
      }
    }

    let i = 0;
    let j = 0;
    while (i < n && j < m) {
      if (midA[i] === midB[j]) { push('same', midA[i]); i += 1; j += 1; } else if (lcs[i + 1][j] >= lcs[i][j + 1]) { push('del', midA[i]); i += 1; } else { push('ins', midB[j]); j += 1; }
    }
    while (i < n) { push('del', midA[i]); i += 1; }
    while (j < m) { push('ins', midB[j]); j += 1; }
  }

  push('same', a.slice(endA).join(''));
  return parts;
}
